import { Resource } from 'src/tracker/model/tracker-model'
import { ResourceProperty } from '../resource-meta/resource-property'

export const btTokenProperty = new ResourceProperty(
  '73b7733a-3fe1-4c4a-9302-ea50cfcf16f7',
  'BT Tokens',
  'btTokens',
  Resource.BT_TOKENS,
)
